import { initSwiper } from '../../components/swiper';
import initAtcPopup from '../../components/atc-popup';

const initCartRecommendations = async () => {
  const containerEl = document.querySelector('[data-cart-recommendations]');
  const url = containerEl?.dataset.url;
  if (!url) return;

  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    containerEl.innerHTML = await response.text();

    const sliderEl = containerEl.querySelector('[data-swiper]');
    if (sliderEl) initSwiper(sliderEl);
    initAtcPopup();
    if (typeof window.ReloadSmartWishlist === 'function') {
      await window.ReloadSmartWishlist();
    }
  } catch (err) {
    console.error('Error fetching cart recommendations:', err);
  }
};

export default initCartRecommendations;
